// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */

export var TypeAheadAvailableNodes = /*#__PURE__*/function (TypeAheadAvailableNodes) {
  TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
  TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
  TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
  return TypeAheadAvailableNodes;
}({});
export var SelectItemMode = /*#__PURE__*/function (SelectItemMode) {
  SelectItemMode["SHIFT_ENTER"] = "shift-enter";
  SelectItemMode["ENTER"] = "enter";
  SelectItemMode["SPACE"] = "space";
  SelectItemMode["SELECTED"] = "selected";
  SelectItemMode["TAB"] = "tab";
  return SelectItemMode;
}({});
export { typeAheadListMessages } from './messages';